import React, { useEffect, useRef, useState } from "react";
import { DISMISS_REASONS } from "./findingGrammar";

/**
 * Dismiss reason menu (§B4) — a reason is REQUIRED (it is §10.7b's graduation
 * dataset), and the menu framing keeps it a two-second act. "Something else…"
 * opens one text line. onDismiss(note) receives the composed "<slug>: <text>"
 * (or just the slug when there's no free text).
 */
function DismissMenu({ onDismiss, onClose }) {
  const [freeText, setFreeText] = useState(null); // null = the menu; string = the text line
  const ref = useRef(null);

  useEffect(() => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  const pick = (reason) => {
    if (reason.slug === "something_else") {
      setFreeText("");
      return;
    }
    onDismiss(reason.slug);
  };

  return (
    <div className="feat-dismiss" ref={ref} role="menu">
      {freeText === null ? (
        DISMISS_REASONS.map((r) => (
          <button
            key={r.slug}
            type="button"
            className="feat-dismiss__item"
            role="menuitem"
            onClick={() => pick(r)}
          >
            {r.label}
          </button>
        ))
      ) : (
        <form
          className="feat-dismiss__form"
          onSubmit={(e) => {
            e.preventDefault();
            const t = freeText.trim();
            onDismiss(t ? `something_else: ${t}` : "something_else");
          }}
        >
          <input
            className="fk-input"
            autoFocus
            value={freeText}
            onChange={(e) => setFreeText(e.target.value)}
            placeholder="A word on why…"
            aria-label="Dismiss reason"
          />
          <button type="submit" className="feat-dismiss__go">
            Dismiss
          </button>
        </form>
      )}
    </div>
  );
}

export default DismissMenu;
